import { CandidateCount } from "../../../../../models/candidateCount";
import { Resume } from '../../../../../models/resume';
import { JobMatchAction } from '../../../../../models/jobMatchAction';
var UploadSingleResumeController = /** @class */ (function () {
    /*@ngInject*/
    function UploadSingleResumeController($scope, $rootScope, $timeout, $uibModal, $filter, modalService, jobMatchActionsService, alertsAndNotificationsService, resumeService, jobMatchService, candidateService, jobService, MESSAGECONSTANTS, utilityService) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.$filter = $filter;
        this.modalService = modalService;
        this.jobMatchActionsService = jobMatchActionsService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.resumeService = resumeService;
        this.jobMatchService = jobMatchService;
        this.candidateService = candidateService;
        this.jobService = jobService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.utilityService = utilityService;
        Dropzone.autoDiscover = false; // disable dropdown instantiation done in the plugin
    }
    UploadSingleResumeController.prototype.$onInit = function () {
        var _this = this;
        this.initVariables();
        // if(this.controlObject) {
        //     this.controlObject = {
        //         cancel: this.cancelUploadResumes
        //     };
        // }
        this.$scope.$on('cancelUploadResume', function (event, arg) {
            _this.cancelUploadResumes();
        });
        if (this.candidateId !== "") {
            this.isSingleCandidateUpload = true;
        }
        //initialize the variables
        if (!_.isNull(this.jobId) && this.jobId != '') {
            this.jobContextExistsFlag = true;
            this.createJobMatchesObject = {
                companyId: this.$rootScope.userDetails.company.companyId,
                requisitionId: this.jobId,
                candidateIds: [],
                manuallyMatchedFromUI: true,
                transactionId: null,
                isAssociateCandidate: false,
                overrideNoteDetails: []
            };
        }
        this.resumeList = [];
        // get the source types
        this.getAllSourceTypes(function () {
            if (!_.isNull(_this.jobId) && _this.jobId != '') {
                _this.getLastAddedCandidateSourceTypeId();
            }
        });
        // wait for changes to take effect and then create wizard
        this.$timeout(function () {
            //create the wizard
            _this.uploadResumesWizard = _this.createUploadResumeWizard();
            //initialize the drop zone configuration
            var dropzoneElement = document.querySelector("form#resumeUploadDropzone");
            if (dropzoneElement) {
                _this.resumeUploadDropzone = _this.createResumeUploadDropzone();
            }
        }, 300);
        this.getAllActivityTypes();
    };
    UploadSingleResumeController.prototype.initVariables = function () {
        this.defaultJobSourceTypeId;
        this.sourceTypeList = [];
        this.resumeList = [];
        this.sourceType = null;
        this.sourceTypeId = null;
        this.otherSourceTypeNotes = null;
        this.referrerName = null;
        this.referrerEmail = null;
        this.uploadResumesResponse = null;
        this.totalUploads = null;
        this.candidatesList = [];
        this.candidatesToAssociateList = [];
        this.candidateCount = null;
        this.createJobMatchesObject = null;
        // flags
        this.showCandidateUpdateFailureMessage = false;
        this.isSingleCandidateUpload = false;
        this.disableUploadButtonFlag = true;
        this.fileExistsFlag = false;
        this.disablePreviousButtonFlag = false;
        this.disableNextButtonFlag = true;
        this.disableCancelButtonFlag = false;
        this.fileUploadInProgressFlag = false;
        this.mandatoryFieldsError = false;
        this.disableSourceTypesFlag = false;
        this.resumeScoringDoneFlag = false;
        this.scoringCandidatesFlag = false;
        this.gettingCountsFlag = false;
        this.jobContextExistsFlag = false;
        this.associatingCandidatesFlag = false;
        this.selectedAllCandidatesFlag = false;
        this.displaySelectDeselectButtonFlag = true;
        this.additionalMatchRuleVerifiedCopy = false;
        this.additionalMatchRuleVerificationPassedCopy = false;
        this.isDirectCandidateUpdate = true;
    };
    UploadSingleResumeController.prototype.getAllActivityTypes = function () {
        var _this = this;
        this.activityMap = [];
        this.jobService.getActivityTypes(function (data) {
            angular.forEach(data, function (val, key) {
                _this.activityMap[val.value] = val.name;
            });
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    UploadSingleResumeController.prototype.getLastAddedCandidateSourceTypeId = function () {
        var _this = this;
        this.jobService.getLastAddedCandidateSourceTypeId(this.jobId, function (data) {
            _this.defaultJobSourceTypeId = data.lastAddedCandidateSourceTypeId;
            _this._setDefaultSourceType();
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    /**
     * creates the resume upload drop zone.
     */
    UploadSingleResumeController.prototype.createResumeUploadDropzone = function () {
        var _this = this;
        var dropZoneSettings = this._getDropZoneSettings();
        var resumeUploadDropzone = new Dropzone("form#resumeUploadDropzone", dropZoneSettings);
        // add event handlers for the drop zone
        resumeUploadDropzone.on('addedfile', function (file, response) {
            _this.fileExistsFlag = true;
            _this.updateActionButtons();
            $('.dz-progress').css({ top: '70%' });
        });
        resumeUploadDropzone.on('removedfile', function (file, response) {
            // if resume id exists, the file was already uploaded.
            if (!_.isUndefined(file.resumeId)) {
                _this.candidateService.deleteCandidateOnResumeRemove(file.resumeId, function (data) {
                    // candidate deleted if created newly or reverted if it was existing candidate
                    // remove from resume list
                    _.remove(_this.resumeList, {
                        resumeId: file.resumeId
                    });
                    // remove the resume from this.uploadResumesResponse files part. This parsing object (this.uploadResumesResponse) is used later for scoring
                    _.remove(_this.uploadResumesResponse.files, {
                        resumeId: file.resumeId
                    });
                    _this.uploadResumesResponse.successCount = _this.uploadResumesResponse.successCount - 1;
                    _this.totalUploads = _this.totalUploads - 1;
                    if (_this.resumeUploadDropzone.files.length === 0) {
                        _this.fileExistsFlag = false;
                        // enable adding of further files if it was disabled
                        $(".dz-hidden-input").prop("disabled", false);
                    }
                    _this.updateActionButtons();
                }, function (error) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }
            else {
                if (_this.resumeUploadDropzone.files.length === 0) {
                    _this.fileExistsFlag = false;
                    // enable adding of further files if it was disabled
                    $(".dz-hidden-input").prop("disabled", false);
                }
                _this.updateActionButtons();
            }
        });
        resumeUploadDropzone.on('sendingmultiple', function (file, xhr, formData) {
            // disable the upload button to avoid multiple clicks
            _this.disableUploadButtonFlag = true;
            // disable changing of source information
            _this.disableSourceTypesFlag = true;
            // indicate that file upload is in progress
            _this.fileUploadInProgressFlag = true;
            var resumeUpload = {};
            resumeUpload.companyId = _this.$rootScope.userDetails.company.companyId;
            resumeUpload.userId = _this.$rootScope.userDetails.id;
            resumeUpload.resumeSourceTypeId = _this.sourceTypeId;
            resumeUpload.buIdList = [];
            // formData.append('resumeUpload', JSON.stringify(resumeUpload));
            formData.append("companyId", resumeUpload.companyId);
            formData.append("resumeSourceTypeId", resumeUpload.resumeSourceTypeId);
            formData.append("userId", resumeUpload.userId);
            formData.append("buIdList", resumeUpload.buIdList);
            if (_this.sourceType.sourceType == 'Other') {
                formData.append("otherSourceTypeNotes", _this.otherSourceTypeNotes);
            }
            else {
                formData.append("otherSourceTypeNotes", null);
            }
            if (_this.sourceType.sourceType == 'Referral') {
                formData.append("referrerName", _this.referrerName);
                formData.append("referrerEmail", _this.referrerEmail);
            }
            else {
                formData.append("referrerName", null);
                formData.append("referrerEmail", null);
            }
            if (!_.isNull(_this.jobId)) {
                formData.append("jobId", _this.jobId);
            }
            if (_this.candidateId && _this.candidateId != '') {
                formData.append("candidateId", _this.candidateId);
            }
        });
        resumeUploadDropzone.on('successmultiple', function (fileArray, response) {
            // remove file upload in progress flag
            _this.fileUploadInProgressFlag = false;
            // this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.UPLOAD.RESUME_UPLOAD_SUCCESS, 'success');
            _this.uploadResumesResponse = response;
            if (_this.jobContextExistsFlag) {
                _this.createJobMatchesObject.transactionId = _this.uploadResumesResponse.transactionID;
            }
            _this.totalUploads = response.successCount + response.failureCount;
            // go over the list, merge each item into a resume object and add to resume list
            if (angular.isDefined(response.files) && response.files.length > 0) {
                angular.forEach(response.files, function (val, key) {
                    fileArray[key].resumeId = val.resumeId;
                    if (val.isSuccess) {
                        _this.resumeList.push(angular.merge(new Resume(), val));
                    }
                });
            }
            if (_this.uploadResumesResponse.conflicts) {
                if (_this.uploadResumesResponse.conflicts.disallowUpload) {
                    _this.alertsAndNotificationsService.showAlertWithCallBack('Upload Failed', _this.uploadResumesResponse.conflicts.uploadBlockedMessage, 'danger', function () {
                        if (_this.cancelCallback) {
                            _this.cancelCallback();
                        }
                    });
                }
                else if (!_this.uploadResumesResponse.conflicts.disallowUpload && _this.uploadResumesResponse.conflicts.conflictExists) {
                    _this._showConflictsModal(_this.uploadResumesResponse.conflicts);
                }
            }
            else {
                var message = response.message ? response.message : _this.MESSAGECONSTANTS.NOTIFICATIONS.UPLOAD.RESUME_UPLOAD_SUCCESS;
                _this.alertsAndNotificationsService.showBannerMessage(message, 'success');
                if (_this.cancelCallback) {
                    _this.cancelCallback();
                }
            }
            _this.updateActionButtons();
            // disable adding of further files
            $(".dz-hidden-input").prop("disabled", true);
        });
        resumeUploadDropzone.on("error", function (file, error) {
            var elements = document.querySelectorAll(".dz-file-preview");
            angular.forEach(elements, function (element, index) {
                var filename = element.querySelectorAll(".dz-filename span")[0].textContent;
                var errorMessage = element.querySelectorAll(".dz-error-message span")[0];
                if (filename === file.name) {
                    errorMessage.textContent = error.message == undefined ? error : error.message;
                }
            });
            _this.disableNextButtonFlag = false;
        });
        return resumeUploadDropzone;
    };
    UploadSingleResumeController.prototype._getDropZoneSettings = function () {
        var dropZoneSettings = {};
        var maxFilesToUpload = 100;
        if (this.isSingleCandidateUpload) {
            maxFilesToUpload = 1;
        }
        dropZoneSettings = {
            url: this.resumeService.getUploadUrl(),
            paramName: function () {
                return "file";
            },
            acceptedFiles: ".pdf,.xlsx,.docx,.doc",
            maxFiles: maxFilesToUpload,
            maxFilesize: 10,
            maxThumbnailFilesize: 10,
            timeout: 300000,
            addRemoveLinks: true,
            autoProcessQueue: false,
            uploadMultiple: true,
            parallelUploads: 100
        };
        // else {
        //     dropZoneSettings = {
        //         url: this.resumeService.getUploadUrl(),
        //         paramName: () =>  {
        //             return "file";
        //         },
        //         acceptedFiles: ".pdf,.xlsx,.docx,.doc",
        //         maxFiles: 1,
        //         maxFilesize: 10,
        //         maxThumbnailFilesize: 10,
        //         timeout: 300000,
        //         addRemoveLinks: true,
        //         autoProcessQueue: false
        //     }
        // }
        return dropZoneSettings;
    };
    /**
     * create the wizard for the upload resume workflow
     */
    UploadSingleResumeController.prototype.createUploadResumeWizard = function () {
        var _this = this;
        var uploadResumesWizard = $("#uploadResumesWizard").wizard();
        $('#uploadResumesWizard').on('actionclicked.fu.wizard', function (evt, data) {
            if (data.direction == "next") {
                switch (data.step) {
                    case 1:
                        // remove the remove button from the file.
                        $('.dz-remove').remove();
                        if (!_this.resumeScoringDoneFlag) {
                            // disable previous and next (complete) button when processing
                            _this.disableNextButtonFlag = true;
                            _this.disablePreviousButtonFlag = true;
                            // initialize the loading flag
                            _this.scoringCandidatesFlag = true;
                            if (!_this.isSingleCandidateUpload) {
                                _this._runScoringForResumes();
                            }
                            else {
                                _this.runResumeScoringForAssociate(null, null);
                            }
                        }
                        else {
                            //if(!this.jobContextExistsFlag){
                            _this._getCandidateCounts();
                            //}
                        }
                        break;
                    case 2:
                        // do nothing
                        // complete click
                        // handled in finish event
                        break;
                    default:
                        break;
                }
            }
            else if (data.direction == "previous") {
                switch (data.step) {
                    case 1:
                        // not possible
                        break;
                    case 2:
                        _this.updateActionButtons();
                        break;
                    default:
                        break;
                }
            }
        });
        $('#uploadResumesWizard').on('finished.fu.wizard', function (evt, data) {
            if (_this.jobContextExistsFlag) {
                if (_this.candidatesToAssociateList.length != 0) {
                    _this.associateCandidates(function () {
                        if (_this.completeCallback) {
                            _this.completeCallback();
                        }
                    });
                }
                else {
                    if (_this.completeCallback) {
                        _this.completeCallback();
                    }
                }
            }
            else {
                if (_this.completeCallback) {
                    _this.completeCallback();
                }
            }
        });
        return uploadResumesWizard;
    };
    UploadSingleResumeController.prototype._runScoringForResumes = function () {
        var _this = this;
        var jobId = null;
        if (this.jobId !== '' && this.jobId !== undefined && this.jobId !== null) {
            jobId = this.jobId;
        }
        this.resumeService.runResumesForScoring(this.uploadResumesResponse, jobId, function (data) {
            angular.forEach(data, function (val, key) {
                if (_.isNull(val.firstName)) {
                    val.firstName = "-";
                }
                if (_.isNull(val.lastName)) {
                    val.lastName = "-";
                }
                if (_.isNull(val.email)) {
                    val.email = "-";
                }
                if (_.isNull(val.phone)) {
                    val.phone = "-";
                }
                val.name = val.firstName + ' ' + val.lastName;
                if (val.mobilePhoneCountryCodePresent) {
                    var phoneNumberObject = libphonenumber.parse(val.phone.toString());
                    if (phoneNumberObject.phone !== undefined) {
                        val.phone = libphonenumber.format(phoneNumberObject.phone, phoneNumberObject.country, 'International');
                    }
                }
                // floor the match score to the lower integer value.
                val.score = Math.floor(parseFloat(val.score));
                val.selectedFlag = false;
                if (val.score >= val.jobThresholdScore) {
                    val.intelligenceScorePassFlag = true;
                }
                _this.candidatesList.push(val);
            });
            _this.scoringCandidatesFlag = false;
            _this.resumeScoringDoneFlag = true;
            // enable previous and next (complete) button after processing
            _this.disableNextButtonFlag = false;
            _this.disablePreviousButtonFlag = false;
            //if(!this.jobContextExistsFlag){
            if (_this.candidateProcessedCallback) {
                _this.candidateProcessedCallback();
            }
            _this._getCandidateCounts();
            //}
        }, function (error) {
            // do nothing
        });
    };
    UploadSingleResumeController.prototype.runResumeScoringForAssociate = function (contactDetails, type) {
        var _this = this;
        var isUpdate = false;
        if (contactDetails) {
            isUpdate = (type && type === 'save') ? true : false;
            this.uploadResumesResponse.candidateContactDetail = contactDetails;
        }
        this.uploadResumesResponse.file = this.uploadResumesResponse.files[0];
        this.utilityService.showLoadingModal('Saving...');
        this.resumeService.runResumeScoringForAssociate(this.uploadResumesResponse, this.candidateId, this.jobId, isUpdate, function (data) {
            _this.utilityService.hideLoadingModal();
            if (!_this.isSingleCandidateUpload) {
                _this.candidateDetailsToUpdate = data;
                if (!isUpdate) {
                    _this.additionalMatchRuleVerifiedCopy = _this.candidateDetailsToUpdate.additionalMatchRuleVerified;
                    _this.additionalMatchRuleVerificationPassedCopy = _this.candidateDetailsToUpdate.additionalMatchRuleVerificationPassed;
                }
                var fetchNewCandidateDetails = {
                    firstName: _this.candidateDetailsToUpdate.candidateConflictDetails[0].newValue,
                    lastName: _this.candidateDetailsToUpdate.candidateConflictDetails[1].newValue,
                    email: _this.candidateDetailsToUpdate.candidateConflictDetails[2].newValue,
                    phoneNumber: _this.candidateDetailsToUpdate.candidateConflictDetails[3].newValue
                };
                _this.fetchOldCandidateDetails = {
                    firstName: _this.candidateDetailsToUpdate.candidateConflictDetails[0].oldValue,
                    lastName: _this.candidateDetailsToUpdate.candidateConflictDetails[1].oldValue,
                    email: _this.candidateDetailsToUpdate.candidateConflictDetails[2].oldValue,
                    phoneNumber: _this.candidateDetailsToUpdate.candidateConflictDetails[3].oldValue
                };
                if (_this.candidateDetailsToUpdate.candidateUpdated) {
                    if (!isUpdate) {
                        _this.isDirectCandidateUpdate = true;
                    }
                    _this.scoringCandidatesFlag = false;
                    _this.resumeScoringDoneFlag = true;
                    _this.disableNextButtonFlag = false;
                    _this.disablePreviousButtonFlag = false;
                    _this.candidatesList.push(fetchNewCandidateDetails);
                }
                else if (_this.candidateDetailsToUpdate.candidateConflicts) {
                    _this.isDirectCandidateUpdate = false;
                    _this.showCandidateUpdateFailureMessage = true;
                    _this.scoringCandidatesFlag = false;
                    _this.resumeScoringDoneFlag = true;
                    _this.disableNextButtonFlag = false;
                    _this.disablePreviousButtonFlag = false;
                    if (isUpdate) {
                        _this.candidateDetailsToUpdate.additionalMatchRuleVerified = _this.additionalMatchRuleVerifiedCopy;
                        _this.candidateDetailsToUpdate.additionalMatchRuleVerificationPassed = _this.additionalMatchRuleVerificationPassedCopy;
                    }
                }
                else {
                    _this.isDirectCandidateUpdate = false;
                    _this._showConflictsModal(_this.candidateDetailsToUpdate);
                }
                if (_this.candidateProcessedCallback) {
                    _this.candidateProcessedCallback();
                }
            }
            else {
                if (type && type === 'save') {
                    _this.alertsAndNotificationsService.showAlertWithCallBack('Success', 'Candidate details updated successfully.', 'success', function () {
                        // Do Nothing
                    });
                }
                else if (type && type === 'cancel') {
                    _this.alertsAndNotificationsService.showAlertWithCallBack('Update Cancelled', 'Candidate update cancelled. No changes were made to the candidate details.', 'info', function () {
                        // Do Nothing
                    });
                }
                if (_this.completeCallback) {
                    _this.completeCallback();
                }
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            if (_this.completeCallback) {
                _this.completeCallback();
            }
            _this.utilityService.hideLoadingModal();
        });
    };
    UploadSingleResumeController.prototype._showConflictsModal = function (candidateConflictDetails) {
        var _this = this;
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        $(".modal").addClass("upload-resumes-modal-medium");
        this.$timeout(function () {
            var conflictModal = _this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowClass: 'four-dot-five-modal-medium',
                component: 'compareAndUpdateCandidateDetailsModal',
                resolve: {
                    candidateConflictDetails: function () {
                        return candidateConflictDetails;
                    }
                }
            });
            conflictModal.result.then(function (callbackObject) {
                if (callbackObject.callbackType == 'save') {
                    _this.runResumeScoringForAssociate(callbackObject.entity, 'save');
                }
                else if (callbackObject.callbackType == 'cancel') {
                    if (_this.isSingleCandidateUpload) {
                        _this.runResumeScoringForAssociate(callbackObject.entity, 'cancel');
                    }
                    else {
                        _this.scoringCandidatesFlag = false;
                        _this.resumeScoringDoneFlag = true;
                        _this.disableNextButtonFlag = false;
                        _this.disablePreviousButtonFlag = false;
                        _this.candidatesList = [];
                        _this.candidatesList.push(_this.fetchOldCandidateDetails);
                    }
                }
                else {
                    _this.scoringCandidatesFlag = false;
                    _this.resumeScoringDoneFlag = true;
                    _this.disableNextButtonFlag = false;
                    _this.disablePreviousButtonFlag = false;
                    _this.candidatesList = [];
                    _this.candidatesList.push(_this.fetchOldCandidateDetails);
                }
            }, function (dismiss) {
                //do nothing
            });
        }, 300);
    };
    UploadSingleResumeController.prototype.cancelUploadResumes = function () {
        var _this = this;
        var message = "Are you sure you want to cancel ?";
        var showPopUp = true;
        var createCandidatesFlag = false;
        if (this.resumeScoringDoneFlag) {
            // do nothing.
        }
        else {
            // scoring was not done
            if (this.resumeList.length) {
                // resumes were uploaded
                message = "No job matches will be created for the uploaded candidate(s).<br>Do you still want to continue?";
                createCandidatesFlag = true;
            }
            else if (this.resumeUploadDropzone.files.length > 0) {
                // resumes not uploaded, exist in the dropzone
                message = "Are you sure you want to cancel ?<br>Un-uploaded files exist in the upload area.";
            }
            else {
                // no uploaded resumes exist. no need to show confirmation popup.
                showPopUp = false;
            }
        }
        if (showPopUp) {
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
                message: message,
                className: "zIndex1060",
                backdrop: true,
                onEscape: false,
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-info'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    var message = "<p class='text-center'>Creating candidate(s) for uploaded resume(s) <i class='fa fa-spinner fa-spin'></i><br>Please go to Candidates screen to view the candidate(s).</p>";
                    if (result) {
                        if (createCandidatesFlag) {
                            var createUploadedCandidatesDialog_1 = bootbox.dialog({
                                message: message,
                                closeButton: false
                            });
                            // scoring was not done and but resumes were uploaded.
                            // make service call to create candidates
                            _this.resumeService.runResumesWithoutScoring(_this.uploadResumesResponse, _this.jobId, function (data) {
                                createUploadedCandidatesDialog_1.modal('hide');
                                _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                                // candidates added successfully without creating job matches
                                if (_this.cancelCallback) {
                                    _this.cancelCallback();
                                }
                            }, function (error) {
                                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                            });
                        }
                        else {
                            if (_this.cancelCallback) {
                                _this.cancelCallback();
                            }
                        }
                    }
                    else {
                        _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    }
                }
            });
        }
        else {
            if (this.cancelCallback) {
                this.cancelCallback();
            }
        }
    };
    /**
     * update the action buttons
     */
    UploadSingleResumeController.prototype.updateActionButtons = function () {
        var _this = this;
        // if resumes exist and scoring is completed, then the functions on this tab are disabled.
        if (this.resumeList.length > 0) {
            this.disableSourceTypesFlag = true;
            this.resumeUploadDropzone.clickable = false;
            this.disableUploadButtonFlag = true;
            this.disableNextButtonFlag = false;
        }
        else {
            // in else because no resumes have been uploaded yet
            if (this.fileExistsFlag) {
                // if files exist in drop zone
                if (!_.isNull(this.sourceTypeId)) {
                    // and source type is chosen
                    this.disableUploadButtonFlag = false;
                    // this.disableSourceTypesFlag = true;
                }
                else {
                    // and source type is not chosen
                    this.disableUploadButtonFlag = true;
                    // this.disableSourceTypesFlag = false;
                }
            }
            else {
                // files do not exist in drop zone
                this.disableUploadButtonFlag = true;
                this.disableSourceTypesFlag = false;
            }
            // disable the next button
            this.disableNextButtonFlag = true;
        }
        this.$timeout(function () {
            _this.$scope.$apply();
        }, 200);
    };
    UploadSingleResumeController.prototype.candidateToAssociateToggle = function (candidate) {
        // if it is selected, add to associate list
        if (candidate.selectedFlag) {
            this.candidatesToAssociateList.push(candidate);
        }
        else {
            // if selected is removed, remove from candidates to associate list
            _.remove(this.candidatesToAssociateList, {
                candidateId: candidate.candidateId
            });
            _.remove(this.createJobMatchesObject.overrideNoteDetails, {
                candidateId: candidate.candidateId
            });
        }
    };
    UploadSingleResumeController.prototype.associateCandidates = function (successCallback) {
        var _this = this;
        angular.forEach(this.candidatesToAssociateList, function (val, key) {
            _this.createJobMatchesObject.candidateIds.push(val.candidateId);
        });
        this.associatingCandidatesFlag = true;
        var associatingDialog = bootbox.dialog({
            message: '<p class="text-center">Adding Candidates <i class="fa fa-spinner fa-spin"></i></p>',
            closeButton: false
        });
        this.createJobMatchesObject.isAddCandidate = true;
        this.jobMatchService.createJobMatches(this.createJobMatchesObject, function (data) {
            _this.associatingCandidatesFlag = false;
            associatingDialog.modal('hide');
            _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            angular.forEach(_this.candidatesToAssociateList, function (val, key) {
                // find each associated candidate in the original candidates list
                var index = _.findIndex(_this.candidatesList, {
                    candidateId: val.candidateId
                });
                // for each candidate, set the added successfully flag to true and selected flag to false
                _this.candidatesList[index].candidateMatchedToJob = true;
                _this.candidatesList[index].statusOfJobMatch = 'Candidate Added.';
                _this.candidatesList[index].selectedFlag = false;
            });
            // make the candidates to associate list as empty.
            _this.candidatesToAssociateList = [];
            // get the candidate counts again as manually matched counts might have changed.
            _this._getCandidateCounts();
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.associatingCandidatesFlag = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UploadSingleResumeController.prototype._getCandidateCounts = function () {
        var _this = this;
        // get counts of candidates that matched jobs.
        // call the get counts API
        this.gettingCountsFlag = true;
        this.resumeService.getCandidateCount(this.uploadResumesResponse.transactionID, function (data) {
            _this.candidateCount = angular.merge(new CandidateCount(), data);
            if (_this.candidateCount.unMatchedCandidateCount == 0) {
                _this.displaySelectDeselectButtonFlag = false;
            }
            _this.updateActionButtons();
            _this.gettingCountsFlag = false;
        }, function (error) {
            _this.gettingCountsFlag = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UploadSingleResumeController.prototype.displayCandidates = function (countType) {
        var _this = this;
        $(".modal").addClass("upload-resumes-modal-medium");
        this.$timeout(function () {
            _this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                component: 'uploadResumesTransactionCandidatesModal',
                windowTopClass: 'upload-resumes-candidates-modal-large',
                resolve: {
                    countsObject: function () {
                        return _this.candidateCount;
                    },
                    countType: function () {
                        return countType;
                    },
                    activityMap: function () {
                        return _this.activityMap;
                    }
                }
            });
        }, 300);
    };
    UploadSingleResumeController.prototype.showOverrideCandidateSuspensionModal = function (candidate) {
        var _this = this;
        var candidateId = candidate.candidateId;
        var candidateName = candidate.name;
        var suspendedMonths = candidate.overrideFor === "RELEASE" ? candidate.releasedCandidateDetailDTO.numberOfMonthsToWait : candidate.jobLeftCandidateDetailDTO.numberOfMonthsToWait;
        var releaseDate = candidate.overrideFor === "RELEASE" ? candidate.releasedCandidateDetailDTO.releasedAt : candidate.jobLeftCandidateDetailDTO.leftAt;
        var allowOverride = candidate.allowOverride;
        var releasedJobDetails = candidate.overrideFor === "RELEASE" ? candidate.releasedCandidateDetailDTO : candidate.jobLeftCandidateDetailDTO;
        var type = candidate.overrideFor === "RELEASE" ? "release" : "jobLeft";
        if (allowOverride) {
            $(".modal").addClass("upload-resumes-modal-medium");
            this.$timeout(function () {
                var warningModal = _this.$uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    backdrop: 'static',
                    windowClass: 'four-dot-five-modal-medium',
                    component: 'uploadResumesActionsModal',
                    resolve: {
                        candidateId: function () {
                            return candidateId;
                        },
                        candidateName: function () {
                            return candidateName;
                        },
                        suspendedMonths: function () {
                            return suspendedMonths;
                        },
                        releaseDate: function () {
                            return releaseDate;
                        },
                        allowOverride: function () {
                            return allowOverride;
                        },
                        releasedJobDetails: function () {
                            return releasedJobDetails;
                        },
                        type: function () {
                            return type;
                        }
                    }
                });
                warningModal.result.then(function (callbackObject) {
                    if (callbackObject.callbackType == 'save') {
                        var index = _.findIndex(_this.candidatesList, {
                            candidateId: candidate.candidateId
                        });
                        _this.createJobMatchesObject.overrideNoteDetails.push(callbackObject.entity);
                        _this.candidatesList[index].allowManualMatch = true;
                        _this.candidatesList[index].showOverride = false;
                        _this.candidatesList[index].statusOfJobMatch = 'Candidate is made available for matching.';
                        _this.candidatesList[index].selectedFlag = true;
                        _this.candidateToAssociateToggle(_this.candidatesList[index]);
                    }
                }, function (dismiss) {
                    //do nothing
                });
            }, 300);
        }
        else {
            var displayHtmlText = "";
            if (type == 'release') {
                displayHtmlText = "Candidate '<span class='emerald'>" + candidateName + "</span>' cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of candidate's previous release. ";
                displayHtmlText = displayHtmlText + "Candidate was previously released on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
                displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
            }
            else {
                displayHtmlText = "Candidate <span class='emerald'>'" + candidateName + "'</span> cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of leaving previous job. ";
                displayHtmlText = displayHtmlText + "Candidate left previous job on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
                displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
            }
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Cannot add candidate</strong></div>",
                message: displayHtmlText,
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: function () {
                    _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }
    };
    UploadSingleResumeController.prototype.getAllSourceTypes = function (successCallback) {
        var _this = this;
        this.resumeService.getAllSourceTypes(function (data) {
            _this.sourceTypeList = data;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    UploadSingleResumeController.prototype._setDefaultSourceType = function () {
        var _this = this;
        if (this.defaultJobSourceTypeId !== undefined && this.defaultJobSourceTypeId !== "" && !_.isNull(this.defaultJobSourceTypeId)) {
            var index = this.sourceTypeList.findIndex(function (sourceType) {
                return sourceType.id == _this.defaultJobSourceTypeId;
            });
            if (index !== -1) {
                this.sourceType = this.sourceTypeList[index];
                this.sourceTypeId = this.sourceType.id;
            }
        }
    };
    UploadSingleResumeController.prototype.sourceTypeChanged = function () {
        if (angular.isDefined(this.sourceType) && angular.isDefined(this.sourceType.id)) {
            this.sourceTypeId = this.sourceType.id;
            this.updateActionButtons();
        }
        else {
            this.sourceTypeId = null;
        }
    };
    UploadSingleResumeController.prototype.uploadResumes = function () {
        this.uploadResumesForm.$submitted = true;
        if (!this.uploadResumesForm.$invalid) {
            this.resumeUploadDropzone.processQueue();
        }
    };
    UploadSingleResumeController.prototype.toggleSelectAllCandidates = function () {
        var _this = this;
        if (this.selectedAllCandidatesFlag) {
            // if selectAllCandidates was already selected, remove all selections
            angular.forEach(this.candidatesList, function (val, key) {
                // if candidate was not already added successfully and was selected, de select it and remove it from associate list
                if (!val.candidateMatchedToJob && val.selectedFlag && val.allowManualMatch) {
                    val.selectedFlag = false;
                    // if selected is removed, remove from candidates to associate list
                    _.remove(_this.candidatesToAssociateList, {
                        candidateId: val.candidateId
                    });
                }
            });
            this.selectedAllCandidatesFlag = false;
        }
        else {
            // if selectAllCandidates was not already selected
            angular.forEach(this.candidatesList, function (val, key) {
                // if candidate was not already added successfully and also not already selected, select it and add to associate list
                if (!val.candidateMatchedToJob && !val.selectedFlag && val.allowManualMatch) {
                    val.selectedFlag = true;
                    _this.candidatesToAssociateList.push(val);
                }
            });
            this.selectedAllCandidatesFlag = true;
        }
    };
    UploadSingleResumeController.prototype.jobCompare = function (candidate) {
        var actionObject = new JobMatchAction("Candidate Job Comparison", "CANDIDATE_JOB_COMPARE", true, null);
        candidate.id = candidate.candidateId;
        candidate.jobMatchJobId = this.jobId;
        this.jobMatchActionsService.performAction('uploadResumes', actionObject, candidate, function () {
        }, function () {
        });
    };
    UploadSingleResumeController.prototype.receiveFormalizedComment = function (event) {
        this.otherSourceTypeNotes = event;
    };
    UploadSingleResumeController.prototype.onVoiceTranscript = function (transcript) {
        if (this.otherSourceTypeNotes) {
            this.otherSourceTypeNotes += ' ' + transcript;
        }
        else {
            this.otherSourceTypeNotes = transcript;
        }
    };
    return UploadSingleResumeController;
}());
UploadSingleResumeController.$inject = ['$scope', '$rootScope', '$timeout', '$uibModal', '$filter', 'modalService', 'jobMatchActionsService', 'alertsAndNotificationsService', 'resumeService', 'jobMatchService', 'candidateService', 'jobService', 'MESSAGECONSTANTS', 'utilityService'];
import * as TEMPLATE from 'raw-loader!./upload-single-resume.html';
export var UploadSingleResumeComponent = {
    selector: 'uploadSingleResume',
    component: {
        bindings: {
            jobId: '@',
            candidateId: '@',
            cancelCallback: '&',
            candidateProcessedCallback: '&',
            completeCallback: '&',
            controlObject: '=',
            context: '@',
            formalizeActivityPayload: '<',
            sourceScreen: '@'
        },
        controller: UploadSingleResumeController,
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=upload-single-resume.component.js.map